export default __webpack_public_path__ + "static/media/PendaLovelace.692b8cc1.png";